import { render, staticRenderFns } from "./signName.vue?vue&type=template&id=482896f2&scoped=true"
import script from "./signName.vue?vue&type=script&lang=js"
export * from "./signName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482896f2",
  null
  
)

export default component.exports